import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'
import { CalendarSimpleVO, CalendarServiceProxy } from '@/service-proxies/app-v2/time.service-proxies'
import { Column } from 'ant-design-vue/types/table/column'
import { Reactive } from '@/utils/decorators'
import { state, actions } from '../store'
import { Loading } from '../types'
const csp = new CalendarServiceProxy()

@Component
export default class CalendarTable extends Vue {
  @Reactive(state) readonly calendarList = []
  @Reactive(state) readonly loading: Loading = {}
  @Reactive(state) readonly currentCalendarId = ''
  @Reactive(state) readonly currentCalendarDetail = null
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;
  @Prop({ default: ""}) readonly selectId: String;
  isEdit = false


  get canUpdateOrDelete() {
    return !!this.currentCalendarId
  }

  get columns(): Partial<Column>[] {
    return [
      {
        title: this.$t('actions'),
        dataIndex: 'id',
        width: 70,
        customRender: (v, record) => {
          return (
            <div class="flex align-items-center">
              <a style="margin-left: auto" disabled={!this.canUpdateOrDelete} onClick={() => this.handleEdit(record.id)}>
                {this.$t('edit')}
              </a>
           <a-divider type="vertical"/>
           <a-popconfirm
                  title={this.$t('page_place_is_not_on_file')}
                  onConfirm={() => this.changeStatus(record)}
                  okText={this.$t("yes")}
                  cancelText={this.$t("no")}>
              <a
                href="javascript:;"
                style="color:red"
              >
                {this.$t("page_place_on_file")}
              </a>
            </a-popconfirm>
   
          </div>
          )
        },
      },
      {
        title: this.$t('page_calendar_code'),
        dataIndex: 'code',
        key: 'code',
        ellipsis: true,
        width: 80,
      },
      {
        title: this.$t('page_calendar_name'),
        dataIndex: 'name',
        key: 'name',
        ellipsis: true,
        width: 80,
      },
      {
        title: this.$t('page_calendar_use_year'),
        dataIndex: 'year',
        key: 'year',
        ellipsis: true,
        width: 80,
      },
    ]
  }

  get customRow() {
    return (record: CalendarSimpleVO) => ({
      on: {
        click: () => {
          actions.setCurrentCalendarId(record.id)
          this.$emit('clickRow',record)
        },
      },
    })
  }

  @Watch('currentCalendarDetail')
  changeDetail() {
    if (this.isEdit) {
      actions.setVisible({ updateForm: true })
      this.isEdit = false
    }
  }
 
  async changeStatus(record) {
    await csp.rename(record.id, record.name, 0)
    this.$message.success(this.$t("page_place_on_file_success"));
    actions.loadCalendarList()
  }

  handleEdit(id) {
    if (id === this.currentCalendarId) {
      actions.setVisible({ updateForm: true })
    } else {
      this.isEdit = true
      actions.setCurrentCalendarId(id)
    }
  }

  onSelectChange(selectedRowKeys) {
    this.$emit('onSelectChange',selectedRowKeys)
  }

  render() {
    return (
      <ml-table
        size="small"
        columns={this.columns}
        dataSource={this.calendarList}
        customRow={this.customRow}
        pagination={false}
        loading={this.loading.calendarTable}
        canChangeColWidth={true}
        bordered
        row-key="id"
        selectRowKey={this.selectId}
        // rowClassName={record => (record.id === this.currentCalendarId ? 'calendar__current-row' : '')}
        row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
      />
    )
  }
}
